module.exports = __webpack_public_path__ + "static/media/archive3.30941713.svg";